import { RefObject } from "react";
import { classNames } from "primereact/utils";
import { AiChatEntry } from "../utilities/aiChatEntriesUtility";
import { AiChatEntryView } from "./AiChatEntryView";
import { AiEmptyState } from "./AiEmptyState";
import styles from "./AiMessages.module.scss";

interface IAiMessageListProps {
  containerRef: RefObject<HTMLDivElement>;
  entries: AiChatEntry[];
  isLoading: boolean;
  isSending: boolean;
  showEmptyState: boolean;
  onPickExample: (question: string) => void;
  onRetry: () => void;
  onOpenImage: (url: string) => void;
}

export const AiMessageList = ({
  containerRef,
  entries,
  isLoading,
  isSending,
  showEmptyState,
  onPickExample,
  onRetry,
  onOpenImage,
}: IAiMessageListProps) => {
  if (isLoading) {
    return (
      <div className={classNames(styles.messages, styles.messages_skeleton)} aria-busy="true">
        {[1, 2, 3].map((index) => (
          <div
            key={index}
            className={classNames(styles.skeleton_bubble, { [styles.skeleton_bubble_user]: index % 2 === 1 })}
          />
        ))}
      </div>
    );
  }

  if (showEmptyState) {
    return (
      <div className={classNames(styles.messages, styles.messages_empty)}>
        <AiEmptyState onPickExample={onPickExample} />
      </div>
    );
  }

  return (
    // column-reverse keeps the newest message in view as the answer grows (scrollTop 0 = bottom).
    <div ref={containerRef} className={styles.messages}>
      <div className={styles.messages_inner} role="log" aria-live="polite" aria-busy={isSending}>
        {entries.map((entry) => (
          <AiChatEntryView key={entry.key} entry={entry} onRetry={onRetry} onOpenImage={onOpenImage} />
        ))}
      </div>
    </div>
  );
};
